import * as StorageUtils from "./lib/util/StorageUtils";
import { User } from "./lib/types/UserTypes";
import { Locale } from "./lib/util/LocaleUtils";
import { Fleet } from "./lib/types/Fleet";
import { TimeSelectionId } from "./lib/util/PillarDataUtils";
import { ExportType } from "./lib/util/DownloadUtils";
import { AppInfo } from "./lib/util/EnvironmentUtils";
import { Credential } from "./lib/util/AuthUtils";

export const SUPPORT_MONITORING_KEY = StorageUtils.createStorageKey<boolean>(
	"BRIGHTMILE_SUPPORT_MONITORING",
	true,
);
export const SUPPORT_SHOW_LOCAL_TIMES_KEY =
	StorageUtils.createStorageKey<boolean>(
		"BRIGHTMILE_SUPPORT_SHOW_LOCAL_TIMES",
		true,
	);
export const FRAME_TOKEN_KEY = StorageUtils.createStorageKey<string>(
	"BRIGHTMILE_FRAME_TOKEN",
);
/** @deprecated */
export const USER_TOKEN_KEY = StorageUtils.createStorageKey<string>(
	"BRIGHTMILE_USER_TOKEN",
);
/** @deprecated */
export const USER_REFRESH_TOKEN_KEY = StorageUtils.createStorageKey<string>(
	"BRIGHTMILE_REFRESH_USER_TOKEN",
);
export const USER_ID_KEY =
	StorageUtils.createStorageKey<string>("BRIGHTMILE_USER_ID");
/** @deprecated use USER_AUTH_LEVEL_KEY instead **/
export const USER_LEVEL_KEY = StorageUtils.createStorageKey<string>(
	"BRIGHTMILE_USER_LEVEL",
);
export const USER_OBJECT_KEY = StorageUtils.createStorageKey<User>(
	"BRIGHTMILE_USER_OBJECT",
);
export const FLEETS_KEY =
	StorageUtils.createStorageKey<Fleet[]>("BRIGHTMILE_FLEETS");
export const OVERRIDE_FLEET_KEY = StorageUtils.createStorageKey<string>(
	"BRIGHTMILE_FLEET_OVERRIDE",
);
export const OVERRIDE_PROGRAM_KEY = StorageUtils.createStorageKey<string>(
	"BRIGHTMILE_PROGRAM_OVERRIDE",
);
export const SELECTED_GROUP_KEY = StorageUtils.createStorageKey<string>(
	"BRIGHTMILE_SELECTED_GROUP",
);
export const SELECTED_ROOT_GROUP_KEY = StorageUtils.createStorageKey<string>(
	"BRIGHTMILE_SELECTED_ROOT_GROUP",
);
export const USER_CLAIMS_KEY = StorageUtils.createStorageKey<Credential>(
	"BRIGHTMILE_USER_CLAIMS",
);
export const CURRENT_LOCALE_CODE_KEY = StorageUtils.createStorageKey<string>(
	"BRIGHTMILE_LANG_CODE",
);
export const CURRENT_LOCALE_KEY =
	StorageUtils.createStorageKey<Locale>("BRIGHTMILE_LANG");

export const APP_KEY = StorageUtils.createStorageKey<AppInfo>("BRIGHTMILE_APP");
/** @deprecated use EMULATED_USER_AUTH_LEVEL_KEY instead **/
export const EMULATED_USER_LEVEL_KEY = StorageUtils.createStorageKey<string>(
	"BRIGHTMILE_EMULATED_USER_LEVEL",
);
export const EMULATED_FLEET_ID_KEY = StorageUtils.createStorageKey<string>(
	"BRIGHTMILE_EMULATED_FLEET_ID",
);
export const EMULATED_GROUP_ID_KEY = StorageUtils.createStorageKey<string>(
	"BRIGHTMILE_EMULATED_GROUP_ID",
);

export const EMULATED_USER_AUTH_LEVEL_KEY =
	StorageUtils.createStorageKey<number>("BRIGHTMILE_EMULATED_AUTH_USER_LEVEL");
export const USER_AUTH_LEVEL_KEY = StorageUtils.createStorageKey<number>(
	"BRIGHTMILE_AUTH_USER_LEVEL",
);

export const TIME_RANGE_KEYS = {
	BOXPLOTS: StorageUtils.createStorageKey<TimeSelectionId>(
		"BRIGHTMILE_TIME_RANGE_BOXPLOTS",
	),
	DASHBOARD_PILLARS: StorageUtils.createStorageKey<TimeSelectionId>(
		"BRIGHTMILE_TIME_RANGE_DASHBOARD_PILLARS",
	),
	DASHBOARD_SPEEDING_MAGNITUDE: StorageUtils.createStorageKey<TimeSelectionId>(
		"BRIGHTMILE_TIME_RANGE_DASHBOARD_SPEEDING_MAGNITUDE",
	),
	DASHBOARD_POI: StorageUtils.createStorageKey<TimeSelectionId>(
		"BRIGHTMILE_TIME_RANGE_DASHBOARD_POI",
	),
	DRIVER_PROFILE_PILLARS: StorageUtils.createStorageKey<TimeSelectionId>(
		"BRIGHTMILE_TIME_RANGE_DRIVER_PROFILE_PILLARS",
	),
	DRIVER_PROFILE_CHARACTERISTICS:
		StorageUtils.createStorageKey<TimeSelectionId>(
			"BRIGHTMILE_TIME_RANGE_DRIVER_PROFILE_CHARACTERISTICS",
		),
	DRIVER_PROFILE_SPEEDING_MAGNITUDE:
		StorageUtils.createStorageKey<TimeSelectionId>(
			"BRIGHTMILE_TIME_RANGE_DRIVER_PROFILE_SPEEDING_MAGNITUDE",
		),
	EXPORT_PPT: StorageUtils.createStorageKey<
		Exclude<TimeSelectionId, "2 months" | "12 months">
	>("BRIGHTMILE_TIME_RANGE_EXPORT_PPT"),
	EXPORT_PPT_OUTLIERS: StorageUtils.createStorageKey<
		Exclude<TimeSelectionId, "2 months" | "6 months" | "12 months">
	>("BRIGHTMILE_TIME_RANGE_EXPORT_PPT_OUTLIERS"),
	COMPARE: StorageUtils.createStorageKey<TimeSelectionId>(
		"BRIGHTMILE_TIME_RANGE_COMPARE",
	),
};

export const EXPORT_BUTTON_KEYS = {
	DEFAULT_IMAGE: StorageUtils.createStorageKey<ExportType>(
		"BRIGHTMILE_DEFAULT_EXPORT_TYPE_IMAGE",
		"pdf",
	),
	DEFAULT_SPREADSHEET: StorageUtils.createStorageKey<ExportType>(
		"BRIGHTMILE_DEFAULT_EXPORT_TYPE_SPREADSHEET",
		"xlsx",
	),
	DASHBOARD: StorageUtils.createStorageKey<ExportType>(
		"BRIGHTMILE_DEFAULT_EXPORT_TYPE_DASHBOARD",
		"pdf",
	),
	COMPARE: StorageUtils.createStorageKey<ExportType>(
		"BRIGHTMILE_DEFAULT_EXPORT_TYPE_COMPARE",
		"pdf",
	),
};

export const TRENDS_AVAILABLE_KEY = StorageUtils.createStorageKey<{
	[key: string]: boolean;
}>("BRIGHTMILE_TRENDS_AVAILABLE");
